<template>
  <Content>
    <div class="md-layout container">
      <div class="md-layout-item md-size-50">
        <div class="md-card-perfil">
          <md-card-header>
            <div
              class="title-card"
            >
              {{ client.identification | mask(client.identification.length == 11 ? '###.###.###-##' : '##.###.###/####-##') }}
            </div>
          </md-card-header>
          <md-card-content>
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Nome Fantasia</label>
                <md-input
                  v-model="client.businessName"
                />
              </md-field>
              <md-field>
                <label>Razão Social</label>
                <md-input
                  v-model="client.name"
                />
              </md-field>
              <md-field>
                <label>E-mail para acesso sistema</label>
                <md-input
                  v-model="perfil.email"
                  placeholder="E-mail da Conta"/>
              </md-field>
            </div>
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Telefone</label>
                <md-input
                  v-mask="['## #####-####']"
                  v-model="perfil.phone"
                  placeholder="Telefone de contato"/>
              </md-field>
            </div>
            <md-button
              class="md-raised btn-atualizar-mail"
              @click="changeProfile()">Atualizar</md-button>
            <md-button
              class="md-raised md-primary"
              @click="modalAlterPassword = true">Alterar Senha</md-button>
            <md-icon class="icon-perfil">assignment_ind</md-icon>
          </md-card-content>
        </div>
      </div>

      <div
        v-show="modalAlterPassword"
        class="md-layout-item md-size-50">
        <div class="md-card-perfil">
          <md-card-header>
            <div class="title-card">Alteração de senha</div>
          </md-card-header>
          <md-card-content>
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Senha Atual</label>
                <md-input
                  v-model="oldPassword"
                  type="password"
                  placeholder="Senha Atual"/>
              </md-field>
              <md-field>
                <label>Nova Atual</label>
                <md-input
                  v-model="newPassword"
                  type="password"
                  placeholder="Nova Senha"/>
              </md-field>
              <md-field>
                <label>Senha Atual</label>
                <md-input
                  v-model="repeatPassword"
                  type="password"
                  placeholder="Repita a senha"/>
              </md-field>
              <div style="max-width: 300px">
                <password-strength-bar :password="newPassword" />
              </div>
            </div>
            <md-button
              class="md-raised md-primary"
              @click="changePasswd()">Alterar</md-button>
          </md-card-content>
        </div>
      </div>
    </div>
  </Content>
</template>
<script>
import { http } from '../../public/api/backend';
import Content from '../public/Content.vue';
import PasswordStrengthBar from '../../public/password/PasswordStrengthBar.vue'

export default {
  name: 'Perfil',
  components: {
    Content,
    PasswordStrengthBar
  },
  data() {
    return {
      client: [],
      perfil: [],
      modalAlterPassword: false,
      oldPassword: '',
      newPassword: '',
      repeatPassword: '',
      loadingPasswd: false,
    };
  },
  mounted() {
    this.getPerfil()
    this.getClient()
  },
  methods: {
    validateFields() {
      return this.client.name && this.perfil.email
    },

    getPerfil() {
      http.post('application.get-profile')
        .then(response => {
          this.perfil = response.data
        })
    },

    getClient() {
      http.post('application.get-client')
        .then(response => {
          this.client = response.data

          const { phoneCollection } = response.data

          phoneCollection.forEach(phone => {
            this.perfil.phone = phone.areaCode + phone.number
          })
        })
    },

    changeProfile() {
      if (!this.validateFields()) {
        this.$toasted.show('Campos Razão Social e E-mail são obrigatórios', {
          theme: 'outline',
          position: 'bottom-right',
          duration: 5000,
          type: 'error',
          icon: 'error_outline'
        });
        return
      }

      swal({
        title: 'Deseja alterar os dados?',
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Cancelar',
            value: 'cancel',
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: 'OK',
            visible: true,
            closeModal: false
          }
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      })
        .then((value) => {
          if (value === 'cancel') {
            swal.stopLoading()
            swal.close()
            return
          }

          this.putClient()

          http.post('application.put-profile', {
            id: this.perfil.id,
            name: this.client.name,
            email: this.perfil.email,
            allowResellerAccess: this.perfil.allowResellerAccess,
          })
            .then(() => {
              this.$toasted.show('Dados alterados com sucesso!', {
                theme: 'outline',
                position: 'bottom-right',
                duration: 5000,
                type: 'success',
                icon: 'check_circle'
              });
              swal.stopLoading()
              swal.close()
            })
            .catch(() => {
              this.$toasted.show('Não foi possível atualizar os dados', {
                theme: 'outline',
                position: 'bottom-right',
                duration: 5000,
                type: 'error',
                icon: 'error_outline'
              });
            })
        });
    },

    putClient() {
      http.post('application.put-client', {
        name: this.client.name,
        businessName: this.client.businessName,
        email: this.perfil.email,
        identification: this.client.identification,
        serial: this.client.serial,
        phoneCollection: [{
          type: 3,
          number: this.perfil.phone
        }],
      })
    },

    changePasswd() {
      if (this.newPassword !== this.repeatPassword) {
        this.$toasted.show('As senhas não conferem, verifique!', {
          theme: 'outline',
          position: 'bottom-right',
          duration: 5000,
          type: 'error',
          icon: 'error_outline'
        });
        this.loadingPasswd = false;
        return
      }
      http.post('application.change-passwd', {
        new_password: this.newPassword,
        old_password: this.oldPassword,
      })
        .then(() => {
          this.$toasted.show('Senha alterada com sucesso!', {
            theme: 'outline',
            position: 'bottom-right',
            duration: 5000,
            type: 'success',
            icon: 'check_circle'
          });
          this.resetFields()
        })
        .catch(error => {
          this.$toasted.show(error.response.data.error_message, {
            theme: 'outline',
            position: 'bottom-right',
            duration: 5000,
            type: 'error',
            icon: 'error_outline'
          });
        })
    },

    resetFields() {
      this.newPassword = '';
      this.oldPassword = '';
      this.repeatPassword = '';
      this.modalAlterPassword = false;
    },

  },
};
</script>



// WEBPACK FOOTER //
// src/accountant/perfil/Perfil.vue